export const typeCompositionModule={
    "KITCHEN": "Кухня",
    "WARDROBE": "Гардероб",
    "DRESSER": "Комод",
}